import { useQuery } from '@apollo/client'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import {
  GetConfigVarsDocument,
  UserPermissionsByIdQuery,
  UserPinStatusEnum,
} from '../../../generated/graphql'
import { TextFieldInput } from '../../../inputs/text-field-input'
import { BaseUserContext } from '../shared'

type Props = {
  permissions?: UserPermissionsByIdQuery['userPermissionsById']
  isNewUser?: boolean
}

export const PinField = ({ isNewUser, permissions }: Props) => {
  const { t } = useTranslation(['users'])
  const { formState, watch, control } = useFormContext<BaseUserContext>()
  const { data: configVarsData } = useQuery(GetConfigVarsDocument)

  if (!permissions?.changePin || configVarsData?.configVars.posUsingAuthV2) {
    return null
  }

  const pinStatus = watch('pin_status')

  return (
    <TextFieldInput
      name="pin"
      type="password"
      control={control}
      label={t('pin')}
      helperText={
        formState.errors.pin?.message || t('users:user_form.pin_helper')
      }
      error={!!formState.errors.pin}
      data-testid="user-pin-input"
      disabled={!isNewUser && !permissions?.changePin}
      slotProps={{ htmlInput: { maxLength: 6 } }}
      transform={{
        input: (value) => {
          if (typeof value === 'string') {
            return value
          } else if (UserPinStatusEnum.FourDigits === pinStatus) {
            return '•'.repeat(4)
          } else if (UserPinStatusEnum.SixDigits === pinStatus) {
            return '•'.repeat(6)
          } else {
            return ''
          }
        },
        output: (event) => {
          const value = event.target.value
          if (value.includes('•')) {
            return ''
          }
          return value
        },
      }}
    />
  )
}
